// Логика таблицы «Просроченной ДЗ» без React и Chakra — её проверяют тесты.

export const NO_FILTER_COLUMNS = new Set(["DealTitle"]);
export const NUMBER_COLUMNS = new Set(["OverdueRub", "OverdueDays"]);
// Заголовки с заданным переносом — столбец сжимается почти до ширины значений.
export const HEADER_LINES = { DzReceiveDate: ["Дата оплаты", "по договору"] };

export const formatDate = (value) => {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}/.test(value)) return value ?? "";
  const [y, m, d] = value.slice(0, 10).split("-");
  return `${d}.${m}.${y}`;
};

export const formatMoney = (value) => {
  const number = Number(value);
  if (value == null || value === "" || !Number.isFinite(number)) return "";
  return number.toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// Текст ячейки — для отображения, фильтра и выгрузки.
export const cellText = (row, key) => {
  const raw = row?.[key];
  if (raw == null) return "";
  if (key === "DzReceiveDate") return formatDate(raw);
  if (key === "OverdueRub") return formatMoney(raw);
  return String(raw).trim();
};

// Ключ сортировки: числа — числом, дата — ISO-строкой, остальное — текстом.
export const sortKey = (row, key) => {
  const raw = row?.[key];
  if (NUMBER_COLUMNS.has(key) || key === "IdDeal") {
    const number = Number(raw);
    return raw == null || raw === "" || !Number.isFinite(number) ? null : number;
  }
  if (key === "DzReceiveDate") return raw ? String(raw).slice(0, 10) : null;
  return cellText(row, key) || null;
};

export const compare = (a, b) => {
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;
  if (typeof a === "number" && typeof b === "number") return a - b;
  return String(a).localeCompare(String(b), "ru");
};

export const rowsPassing = (data, filters, skipKey = null) =>
  data.filter((row) =>
    Object.entries(filters).every(([key, selected]) =>
      key === skipKey || selected.has(cellText(row, key))
    )
  );
